import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 *
 * import { ChartsFrame, PanelComponent, Legend, LegendEntryComponent } from "@skve/components";
 * import { ThermometerSnowflake } from "lucide-react";
 *
 * function Demo() {
 *
 * const icons = [
 *                  {
 *                      name: "snowflake",
 *                      icon: ThermometerSnowflake,
 *                      color: "blue"
 *                  }
 *              ]
 *
 *  const children1=<div className="w-full h-full bg-red-700 " />
 *
 * const legendEntry1 = {
 *  type: "restrictionGroup",
 *  name: "Störung",
 *  nameShownAsTooltip: false,
 *  formattedXValue: "3.7. 11:30 - 5.7. 15:45",
 *  formattedYValue: "0 - 0",
 *  unit: "kW",
 *  extension: null
 * }
 *
 * const legendEntry2 = {
 *  type: "restrictionGroup",
 *  name: "Wärme",
 *  nameShownAsTooltip: true,
 *  formattedXValue: "1.7. 14:30 - 2.7. 15:45",
 *  formattedYValue: "300 - 500",
 *  unit: "kW",
 *  extension: null
 * }
 *
 * const legendEntry3 = {
 *  type: "restrictionGroup",
 *  name: "Wärme",
 *  nameShownAsTooltip: true,
 *  formattedXValue: "1.7. 14:30 - 2.7. 15:45",
 *  formattedYValue: "300 - 500",
 *  unit: "kW",
 *  extension: null
 * }
 *
 * const legendEntryComponent1 = <LegendEntryComponent legendEntry={legendEntry1} color="purple" ></LegendEntryComponent>
 * const legendEntryComponent2 = <LegendEntryComponent legendEntry={legendEntry2} color="grey" ></LegendEntryComponent>
 * const legendEntryComponent3 = <LegendEntryComponent legendEntry={legendEntry3} color="grey" ></LegendEntryComponent>
 *
 * const legendEntries = [];
 * legendEntries.push(legendEntryComponent1)
 * legendEntries.push(legendEntryComponent2)
 * legendEntries.push(legendEntryComponent3)
 *
 *  const legend1=<Legend
 *                  legendHeight={126}
 *                   legendEntries={
 *                      legendEntries
 *                  }
 *                  ></Legend>
 *
 *  const children2=<div className="w-full h-full bg-blue-700 " />
 *
 *  const legend2=<Legend
 *                  legendHeight={126}
 *                   legendEntries={
 *                      legendEntries
 *                  }
 *                  ></Legend>
 *
 *  const children =
 *      <div>
 *          <PanelComponent
 *              chartName="Gesamt"
 *              children={children1}
 *              legend={legend1}
 *          />
 *          <PanelComponent
 *              chartName="Gasproduktionsprognose"
 *              children={children2}
 *              legend={legend2}
 *          />
 *      </div>
 *
 *   return <ChartsFrame
 *              color="green"
 *          >
 *              {children}
 *          </ChartsFrame>
 * }
 * ```
 */
const ChartsFrame = ({ children, color, pinned = false, hideLegend = false, }) => (React.createElement("div", { className: cn("border-l-4 bg-chartsframe-frame", hideLegend && "chartsframe--collapsed", pinned && "child-pinned"), style: { borderColor: color } }, children));
ChartsFrame.displayName = "ChartsFrame";
export { ChartsFrame };
//# sourceMappingURL=chartsFrame.js.map